export default "assets/images/icons/mail-9e203384.svg";